module.exports = __webpack_public_path__ + "static/img/demo-update-run.a5832b0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/demo-update-run.png
// module id = 6xef
// module chunks = 0